import { CompanyDocument, PersonalDocument } from '@scansource-brazil/zeus-core-ui/utils';
import { COMPANY_TYPE_ENUM } from '~/enums/CompanyType';

export class CompanyInputDTO {
  economicGroupRoot: string = '';
  companyDocument: string = '';
  companyName: string = '';
  companyType: COMPANY_TYPE_ENUM = COMPANY_TYPE_ENUM.HEADQUARTER;
  phoneNumber: string = '';
  invitedList: InvitedInputDTO[] = [];
  id: string = '';
  created: string | null = null;
  updated: string | null = null;
  valid: boolean = false;
  tenant: string | null = null;
  validationResult: any = null;

  constructor(data: Partial<CompanyInputDTO> = {}) {
    Object.assign(this, data);
  }
}

export class InvitedInputDTO {
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  document: string = '';
  phoneNumber: string = '';
  invitationCode: string = '';
  invitationStatus: number = 0;
  orderNumber: string | null = null;
  invitationDate: string | null = null;

  constructor(data: Partial<InvitedInputDTO> = {}) {
    Object.assign(this, data);
  }
}

export class Invited {
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  document: PersonalDocument = new PersonalDocument();
  phoneNumber: string = '';
  invitationCode: string = '';
  invitationStatus: number = 0;
  orderNumber: string | null = null;
  invitationDate: Date | null = null;

  constructor(data: Partial<Invited> = {}) {
    Object.assign(this, data);
  }
}

export class Company {
  economicGroupRoot: string = '';
  companyDocument: CompanyDocument = new CompanyDocument();
  companyName: string = '';
  companyType: keyof typeof COMPANY_TYPE_ENUM = 'HEADQUARTER';
  phoneNumber: string = '';
  invitedList: Invited[] = [];
  id: string = '';
  created: Date | null = null;
  updated: Date | null = null;
  valid: boolean = false;
  tenant: string | null = null;

  constructor(data: Partial<Company> = {}) {
    Object.assign(this, data);
  }
}
